import { render } from "./GameCredits.vue?vue&type=template&id=e50c7514"
import script from "./GameCredits.vue?vue&type=script&lang=js"
export * from "./GameCredits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__